import InlineEdit from "@atlaskit/inline-edit";
import type {ExtendedFieldProps} from "@atlaskit/inline-edit/dist/types/types";
import {token} from "@atlaskit/tokens";
import type {ComponentProps} from "react";
import {AnankeSelect} from "@vesta/ananke/components/anankeSelect";

export function AnankeTempInlineEditableSelect({
    defaultValue,
    placeholder,
    options,
    ...props
}: Omit<ComponentProps<typeof InlineEdit<{value: string; label: string}>>, "defaultValue" | "onConfirm" | "readView" | "editView"> & {
    defaultValue: {value: string; label: string};
    onConfirm: (value: {value: string; label: string}) => void;
    placeholder: string;
    options: Array<{label: string; value: string}>;
}) {
    return (
        <div className="[&>form>div]:mt-0!">
            <InlineEdit
                {...props}
                defaultValue={defaultValue}
                readView={() => (
                    <ReadView
                        value={defaultValue}
                        placeholder={placeholder}
                    />
                )}
                editView={(fieldProps) => (
                    <EditView
                        fieldProps={fieldProps}
                        options={options}
                    />
                )}
            />
        </div>
    );
}

function ReadView({value, placeholder}: {value: {value: string; label: string}; placeholder: string}) {
    return (
        // <Box xcss={readViewContainerStyles.root}>
        <div
            className="w-full"
            style={{
                // font: token("font.body"),
                // TODO: Temporary, until we get typography working as expected
                fontSize: "0.875rem",
                lineHeight: "1.25rem",
                paddingBlock: token("space.100"),
                paddingInline: token("space.075"),
            }}
        >
            {/* value.value === null || */}
            {value.value === "" ? placeholder : value.label}
        </div>
    );
}

function EditView({
    fieldProps,
    options,
}: {
    fieldProps: ExtendedFieldProps<string>;
    options: Array<{label: string; value: string}>;
}) {
    return (
        <AnankeSelect
            {...fieldProps}
            options={options}
            autoFocus
            openMenuOnFocus
        />
    );
}
